<app-filters-side-panel
  [allowSiteGroups]="false"
  [allowedSiteTypes]="allowedSiteTypes"
  [capabilities]="[CapabilityIdEnum.Engagement]">
  <mat-card>
    <mat-card-content>
      <app-search-bar
        [primaryButtonAction]="primaryButtonAction"
        [searchKey]="'engagement/history/search'"
        [primaryButtonKey]="'engagement/history/new-message'"></app-search-bar>
      <app-table [config]="config" [filters]="filters"></app-table>
    </mat-card-content>
  </mat-card>
</app-filters-side-panel>

<ng-template #errorTemplateRef>
  <strong>{{ errorDisplayed.code }}</strong>
  <p>{{ errorDisplayed.title }}</p>
</ng-template>
